var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Csection class=\"navigation-menu-categories\"\u003E";
// iterate locals.categories
;(function(){
  var $$obj = locals.categories;
  if ('number' == typeof $$obj.length) {
      for (var pug_index0 = 0, $$l = $$obj.length; pug_index0 < $$l; pug_index0++) {
        var category = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"navigation-content\"\u003E\u003Ca" + (" class=\"link\""+pug.attr("href", category.url, true, true)) + "\u003E\u003Cfigure\u003E\u003Cimg" + (" class=\"rounded\""+pug.attr("src", category.image, true, true)+" width=\"110\" height=\"110\"") + "\u003E\u003Cfigcaption class=\"navigation-content-title\"\u003E" + (pug.escape(null == (pug_interp = category.name) ? "" : pug_interp)) + "\u003C\u002Ffigcaption\u003E\u003C\u002Ffigure\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var pug_index0 in $$obj) {
      $$l++;
      var category = $$obj[pug_index0];
pug_html = pug_html + "\u003Cdiv class=\"navigation-content\"\u003E\u003Ca" + (" class=\"link\""+pug.attr("href", category.url, true, true)) + "\u003E\u003Cfigure\u003E\u003Cimg" + (" class=\"rounded\""+pug.attr("src", category.image, true, true)+" width=\"110\" height=\"110\"") + "\u003E\u003Cfigcaption class=\"navigation-content-title\"\u003E" + (pug.escape(null == (pug_interp = category.name) ? "" : pug_interp)) + "\u003C\u002Ffigcaption\u003E\u003C\u002Ffigure\u003E\u003C\u002Fa\u003E\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fsection\u003E\u003Caside class=\"navigation-menu-articles\"\u003E";
// iterate locals.articles
;(function(){
  var $$obj = locals.articles;
  if ('number' == typeof $$obj.length) {
      for (var index = 0, $$l = $$obj.length; index < $$l; index++) {
        var article = $$obj[index];
if (!index) {
pug_html = pug_html + "\u003Carticle class=\"panel panel-hover\"\u003E\u003Ca" + (pug.attr("href", article.url, true, true)) + "\u003E\u003Cimg" + (" class=\"panel-image\""+pug.attr("src", article.image, true, true)+" width=\"250\" height=\"135\"") + "\u003E\u003Cdiv class=\"caption\"\u003E" + (pug.escape(null == (pug_interp = article.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"navigation-article-link\""+pug.attr("href", article.url, true, true)) + "\u003E\u003Ci class=\"glyph glyph-double-arrow-right\"\u003E\u003C\u002Fi\u003E" + (pug.escape(null == (pug_interp = article.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
      }
  } else {
    var $$l = 0;
    for (var index in $$obj) {
      $$l++;
      var article = $$obj[index];
if (!index) {
pug_html = pug_html + "\u003Carticle class=\"panel panel-hover\"\u003E\u003Ca" + (pug.attr("href", article.url, true, true)) + "\u003E\u003Cimg" + (" class=\"panel-image\""+pug.attr("src", article.image, true, true)+" width=\"250\" height=\"135\"") + "\u003E\u003Cdiv class=\"caption\"\u003E" + (pug.escape(null == (pug_interp = article.title) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E\u003C\u002Fa\u003E\u003C\u002Farticle\u003E";
}
else {
pug_html = pug_html + "\u003Ca" + (" class=\"navigation-article-link\""+pug.attr("href", article.url, true, true)) + "\u003E\u003Ci class=\"glyph glyph-double-arrow-right\"\u003E\u003C\u002Fi\u003E" + (pug.escape(null == (pug_interp = article.title) ? "" : pug_interp)) + "\u003C\u002Fa\u003E";
}
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Faside\u003E";;return pug_html;};
module.exports = template;